import { createElement } from 'react';
import { render } from '../../libs/ngsModuleLoader';
import { Banners } from '@sb/banners';
import Translator from '../Translator';

const selectors = {
    container: '.banners-container',
};

const sportIdMap = {
    'american-football': 'OB_SP1', 
    'baseball': 'OB_SP2', 
    'boxing': 'OB_SP5', 
    'cricket': 'OB_SP6', 
    'cycling': 'OB_SP7', 
    'darts': 'OB_SP8', 
    'football': 'OB_SP9', 
    'gaa-football': 'OB_SP10', 
    'golf': 'OB_SP11', 
    'handball': 'OB_SP12', 
    'gaa-hurling': 'OB_SP13', 
    'motor-racing': 'OB_SP18', 
    'tv-specials': 'OB_SP19', 
    'politics': 'OB_SP20', 
    'rugby-league': 'OB_SP21', 
    'rugby-union': 'OB_SP22', 
    'snooker': 'OB_SP23', 
    'tennis': 'OB_SP24', 
    'ufc': 'OB_SP25', 
    'ice-hockey': 'OB_SP26', 
    'basketball': 'OB_SP27', 
    'poker': 'OB_SP28', 
    'winter-sports': 'OB_SP29', 
    'volleyball': 'OB_SP30', 
    'water-polo': 'OB_SP31', 
    'athletics': 'OB_SP32', 
    'bowls': 'OB_SP33', 
    'beach-soccer': 'OB_SP34', 
    'australian-rules': 'OB_SP37', 
    'beach-volleyball': 'OB_SP39', 
    'hockey': 'OB_SP40', 
    'pool': 'OB_SP41', 
    'greyhounds': 'OB_SP42', 
    'horse-racing': 'OB_SP43', 
    'futsal': 'OB_SP45', 
    'bandy': 'OB_SP46', 
    'yachting-sailing': 'OB_SP47', 
    'fishing': 'OB_SP49', 
    'jockey-challenge': 'OB_SP51', 
    'motorbikes': 'OB_SP52', 
    'rowing': 'OB_SP54', 
    'badminton': 'OB_SP55', 
    'table-tennis': 'OB_SP56', 
    'floorball': 'OB_SP57', 
    'delhi-2010': 'OB_SP58', 
    'netball': 'OB_SP59', 
    'financial': 'OB_SP60', 
    'hotbox': 'OB_SP61', 
    'paralympics': 'OB_SP62', 
    'squash': 'OB_SP63', 
    'lacrosse': 'OB_SP64', 
    'swimming': 'OB_SP65', 
    'canoeing': 'OB_SP67', 
    'equestrian': 'OB_SP68', 
    'synchronised-swimming': 'OB_SP69', 
    'triathlon': 'OB_SP70', 
    'shooting': 'OB_SP71', 
    'gymnastics': 'OB_SP72', 
    'archery': 'OB_SP73', 
    'diving': 'OB_SP74', 
    'judo': 'OB_SP75', 
    'fencing': 'OB_SP76', 
    'weightlifting': 'OB_SP77', 
    'taekwondo': 'OB_SP78', 
    'modern-pentathlon': 'OB_SP79', 
    'test-horse-racing': 'OB_SP80', 
    'horse-racing-italy': 'OB_SP81', 
    'softball': 'OB_SP82', 
    'commonwealth-games': 'OB_SP83', 
    'e-sports-dnu': 'OB_SP84', 
    'ten-pin-bowling': 'OB_SP85', 
    'olympics': 'OB_SP86', 
    'e-sports': 'OB_SP87', 
    '6-at-6': 'OB_SP88', 
    'boxing-specials': 'OB_SP89', 
    'street-hockey': 'OB_SP90', 
    'sumo': 'OB_SP91', 
    'virtual-sports': 'OB_SP9899',
};

export const renderNewBanners = (key) => {
    const container = document.querySelector(selectors.container);

    if (!container) {
        console.warn('Banners container not found');
        return;
    }

    if (!window.whStatic?.config?.banners?.baseUrl) {
        console.warn('Banners static config not found');
        return;
    }

    const locale = Translator.getLocale() || 'en-gb';
    const contentStackKey = key || sportIdMap[window.WH.sportsbook.sportEn];

    render(container, {}, () => {
        return createElement(
            Banners,
            {
                contentStackConfig: {
                    environment: window.whStatic.config.banners.env,
                    key: contentStackKey,
                    locale,
                    baseUrl: window.whStatic.config.banners.baseUrl,
                    deliveryToken: window.whStatic.config.banners.deliveryToken,
                    apiKey: window.whStatic.config.banners.apiKey,
                },
                translations: {
                    terms: {
                        buttonLabel: Translator.translate('banners.terms.buttonLabel'),
                    },
                    betslip: {
                        add: {
                            loading: Translator.translate('banners.betslip.add.loading'),
                            success: Translator.translate('banners.betslip.add.success'),
                            error: Translator.translate('banners.betslip.add.error'),
                            alreadyAdded: Translator.translate('banners.betslip.add.alreadyAdded'),
                        },
                    },
                },
            },
        );
    });
};
